import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ProductsLookupService } from '../../../../services/product/lookup.service';
import { CategoryVTO } from '../../../../pages/admin-dashboard/categories/category.model';
import { LanguageService } from '../../../../services/language.service';
import { SafeUrl } from '@angular/platform-browser';
import { ProductsFileMgt } from '../../../../services/product/file-management/products.file-mgt.service';
import { LookupResultSet } from '../../../../pages/admin-dashboard/admin-companies/admin-companies.model';
import { CategoriesIcon } from "../../../../shared/ui/icons/categories-icon/categories-icon";

@Component({
  selector: 'app-categories-list',
  imports: [CategoriesIcon],
  templateUrl: './categories-list.html',
  styleUrl: './categories-list.scss',
})
export class CategoriesList implements OnInit {
  private lookupService = inject(ProductsLookupService);
  private router = inject(Router);
  private languageService = inject(LanguageService);
  private fileMgt = inject(ProductsFileMgt);

  getLocalizedTitle(category: CategoryVTO): string {
    return this.languageService.getCurrentLocale() == 'ar' ? category.titleAr || category.titleEn : category.titleEn;
  }
  categories?: LookupResultSet;
  errorMessage = signal<string>('');
  categoryImages = new Map<number, { url: SafeUrl; isImage: boolean }>();
  ngOnInit() {
    this.lookupService.getLookupCategories().subscribe({
      next: (res) => {
        this.categories = res;
        res.list.forEach((category: CategoryVTO) => {
          if (category.profileImageFid) {
            this.fileMgt.getImageUrl(category.profileImageFid).subscribe({
              next: (data) => this.categoryImages.set(category.id, data),
              error: () => this.categoryImages.set(category.id, { url: '', isImage: false }),
            });
          }
        });
      },
      error: (err) => {
        console.error('Error fetching categories', err);
        this.errorMessage.set($localize`:@@categoriesLoadError:Failed to load categories. Please try again later.`);
      },
    });
  }
  viewCategory(category: CategoryVTO) {
    this.router.navigate(['/user/products'], {
      queryParams: {
        categoryId: category.id,
        categoryTitleEn: category.titleEn,
        categoryTitleAr: category.titleAr,
      },
    });
  }
}
